<template>
  <div class="addAppVersion-dialog">
    <base-dialog
      :model="addData.isOpen"
      @open="open"
      @close="closeDialogHandle"
      :title="addData.title"
    >
      <template #body>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="广告标题" prop="title">
            <el-input v-model.trim="formData.title"></el-input>
          </el-form-item>
          <el-form-item v-if="formData.adType !== 4" label="广告描述" prop="note">
            <el-input v-model.trim="formData.note"></el-input>
          </el-form-item>
            <el-form-item v-if="formData.adType !== 4" label="封面图片" prop="imgUrl" class="dis-sp-center">
              <el-image
                v-if="formData.imgUrl"
                style="width: 100px; height: 100px;margin-right: 20px;"
                :src="$fileUrl + '' + formData.imgUrl"
                :preview-src-list="[$fileUrl + '' + formData.imgUrl]"
                fit="cover"
              >
              </el-image>
              <el-button
                @click="uploadVersion.isOpen = true"
                type="primary"
                size="mini"
                >上传<i class="el-icon-upload el-icon--right"></i
              ></el-button>
            </el-form-item>
          <el-form-item  label="广告类型" prop="adType">
            <el-radio-group v-model="formData.adType">
              <el-radio :label="1">图文</el-radio>
              <el-radio :label="3">外链</el-radio>
              <el-radio :label="2">路由</el-radio>
              <el-radio :label="4">广播</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="formData.adType !== 4" label="广告路径" prop="path">
            <el-input v-model.trim="formData.path"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input v-model.trim="formData.remarks"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <el-button @click="addData.isOpen = false">取 消</el-button>
        <el-button type="primary" @click="addAd">确 定</el-button>
      </template>
    </base-dialog>
    <base-upload-image
    v-if="uploadVersion.isOpen"
      :dialogData="uploadVersion"
      @success="uploadSuccessVersion"
      @close="closeUpload"
    ></base-upload-image>
  </div>
</template>

<script>
import { adInfoSave, getByIdAd } from '@/api/adv'

export default {
  props: {
    addData: {
      type: Object
    }
  },
  data () {
    return {
      formData: {
        title: '',
        note: '',
        remarks: '',
        imgUrl: '',
        adType: '',
        path: ''
      },
      uploadVersion: {
        isOpen: false
      },
      rules: {
        title: [
          {
            required: true,
            message: '请输入广告名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    'addData.isOpen': function (isOpen) {
      if (isOpen) {
      }
      if (isOpen && this.addData.type === 'edit') {
        this.open()
      }
      if (!isOpen) {
        this.resetFormData()
      }
    }
  },
  methods: {
    // 根据id获取版本信息
    open () {
      if (this.addData.id !== '') {
        getByIdAd(this.addData.id).then((res) => {
          Object.keys(this.formData).forEach((item) => {
            this.formData[item] = res.data[item]
          })
          this.formData.id = this.addData.id
        })
      }
    },
    // 上传成功
    uploadSuccessVersion (data) {
      console.log(data)
      this.formData.imgUrl = data.data
      this.uploadVersion.isOpen = false
    },
    // 新增广告
    addAd () {
      if (this.formData.adType !== 1 && this.formData.path === '' && this.formData.adType !== 4) {
        return this.$message({
              message: '请输入路径',
              type: 'error'
            })
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          adInfoSave(this.formData).then((res) => {
            this.$refs.form.resetFields()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.$emit('successHandle')
            this.closeDialogHandle()
          })
        }
      })
    },
    // 重置表单
    resetFormData () {
      this.formData = {
        title: '',
        note: '',
        remarks: '',
        imgUrl: '',
        adType: '',
        path: ''
      }
    },
    // 关闭上传窗口
    closeUpload () {
      this.uploadVersion.isOpen = false
    },
    // 关闭弹窗
    closeDialogHandle () {
      this.addData.isOpen = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .dis-sp-center{
    display: flex;
    align-items: center;
    ::v-deep .el-form-item__content{
      display: flex;
      align-items: center;
      margin-left:0px !important;
    }
  }
</style>
